// extracted by mini-css-extract-plugin
export default {"row":"FileRow_row__tzt7m","text":"FileRow_text__wwAv8"};